<template>
  <div>
    <div class="row">
      <div class="col-lg-12 inline">
        <h2 style="display: inline">Attendance Analytic</h2>
      </div>
      <div class="col-lg-4">
        <h4>
          Select Time:
          <el-select
            class="select-info tab select-width"
            placeholder="Single Select"
            v-model="selects.selectTime"
            @change="selectInterval()"
          >
            <el-option
              v-for="option in selects.time"
              class="select-info"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>

      <div class="col-lg-4">
        <h4>
          Select Department:
          <el-select
            class="select-info tab select-width"
            placeholder="Single Select"
            v-model="selects.selectDept"
            @change="selectDepartment()"
          >
            <el-option
              v-for="option in selects.department"
              class="select-info"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>

      <div class="col-lg-4">
        <h4>
          Select Service Area:
          <el-select
            class="select-info tab select-width"
            placeholder="Single Select"
            v-model="selects.selectArea"
            @change="selectArea()"
            :disabled="disableArea"
          >
            <el-option
              v-for="option in selects.area"
              class="select-info"
              :value="option.value"
              :label="option.label"
              :key="option.label"
            ></el-option>
          </el-select>
        </h4>
      </div>

      <div class="col-lg-6 col-md-12">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <!-- <h5 class="card-category">Weekly</h5> -->
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>No of Manpower Availability</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="noManPower.loaded"
              :chart-data="noManPower.chartData"
              :gradient-colors="noManPower.gradientColors"
              :gradient-stops="noManPower.gradientStops"
              :extra-options="noManPower.extraOptions"
              :height="200"
            ></line-chart>
            <div class="d-flex justify-content-center spinner" v-if="!noManPower.loaded">
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>

      <div class="col-lg-6 col-md-12">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <!-- <h5 class="card-category">Weekly</h5> -->
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>Percentage of Manpower Availability</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="percentManPower.loaded"
              :chart-data="percentManPower.chartData"
              :gradient-colors="percentManPower.gradientColors"
              :gradient-stops="percentManPower.gradientStops"
              :extra-options="percentManPower.extraOptions"
              :height="200"
            ></line-chart>
            <div class="d-flex justify-content-center spinner" v-if="!percentManPower.loaded">
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>

      <div class="col-lg-6 col-md-12">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <!-- <h5 class="card-category">Weekly</h5> -->
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>No of Late In</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="noLateIn.loaded"
              :chart-data="noLateIn.chartData"
              :gradient-colors="noLateIn.gradientColors"
              :gradient-stops="noLateIn.gradientStops"
              :extra-options="noLateIn.extraOptions"
              :height="200"
            ></line-chart>
            <div class="d-flex justify-content-center spinner" v-if="!noLateIn.loaded">
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>

      <div class="col-lg-6 col-md-12">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <!-- <h5 class="card-category">Weekly</h5> -->
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>Percentage of Late In</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="percentLateIn.loaded"
              :chart-data="percentLateIn.chartData"
              :gradient-colors="percentLateIn.gradientColors"
              :gradient-stops="percentLateIn.gradientStops"
              :extra-options="percentLateIn.extraOptions"
              :height="200"
            ></line-chart>
            <div class="d-flex justify-content-center spinner" v-if="!percentLateIn.loaded">
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>

      <div class="col-lg-6 col-md-12">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <!-- <h5 class="card-category">Weekly</h5> -->
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>No of Absent</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="noAbsent.loaded"
              :chart-data="noAbsent.chartData"
              :gradient-colors="noAbsent.gradientColors"
              :gradient-stops="noAbsent.gradientStops"
              :extra-options="noAbsent.extraOptions"
              :height="200"
            ></line-chart>
            <div class="d-flex justify-content-center spinner" v-if="!noAbsent.loaded">
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>

      <div class="col-lg-6 col-md-12">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <!-- <h5 class="card-category">Weekly</h5> -->
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>Percentage of Absent</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="percentAbsent.loaded"
              :chart-data="percentAbsent.chartData"
              :gradient-colors="percentAbsent.gradientColors"
              :gradient-stops="percentAbsent.gradientStops"
              :extra-options="percentAbsent.extraOptions"
              :height="200"
            ></line-chart>
            <div class="d-flex justify-content-center spinner" v-if="!percentAbsent.loaded">
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "src/components/Charts/LineChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import { BaseProgress } from "src/components";
import { Select, Option } from "element-ui";

import moment from "moment";
import swal from "sweetalert2";

import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { time } from "d3";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    LineChart,
    BaseProgress,
    Loading,
    Circle8
  },
  data() {
    return {
      disableArea: true,
      // disableDept: true,
      isLoading: true,
      selects: {
        selectTime: "",
        selectDept: "",
        selectArea: "",
        time: [
          {
            value: "day",
            label: "Daily"
          },
          {
            value: "week",
            label: "Weekly"
          },
          {
            value: "month",
            label: "Monthly"
          },
          {
            value: "year",
            label: "Yearly"
          }
        ],
        department: [
          {
            value: "*",
            label: "All"
          }
        ],
        area: [
          {
            value: "*",
            label: "All"
          }
        ]
      },

      noManPower: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "No of Man Power",
              fill: true,
              borderColor: "rgba(82, 222, 151, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(82, 222, 151, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(82, 222, 151, 0.5)",
          "rgba(82, 222, 151, 0.0)",
          "rgba(82, 222, 151, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      },

      percentManPower: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Percentage of Man Power",
              fill: true,
              borderColor: "rgba(82, 222, 151, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(82, 222, 151, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(82, 222, 151, 0.5)",
          "rgba(82, 222, 151, 0.0)",
          "rgba(82, 222, 151, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      },

      noLateIn: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "No of Late In",
              fill: true,
              borderColor: "rgba(255, 204, 0, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 204, 0, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(255, 204, 0, 0.5)",
          "rgba(255, 204, 0, 0.0)",
          "rgba(255, 204, 0, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      },

      percentLateIn: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Percentage of Late In",
              fill: true,
              borderColor: "rgba(255, 204, 0, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 204, 0, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(255, 204, 0, 0.5)",
          "rgba(255, 204, 0, 0.0)",
          "rgba(255, 204, 0, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      },

      noAbsent: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "No of Absent",
              fill: true,
              borderColor: "rgba(250, 22, 63, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(250, 22, 63, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(250, 22, 63, 0.5)",
          "rgba(250, 22, 63, 0.0)",
          "rgba(250, 22, 63, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      },

      percentAbsent: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Percentage of Absent",
              fill: true,
              borderColor: "rgba(250, 22, 63, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(250, 22, 63, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(250, 22, 63, 0.5)",
          "rgba(250, 22, 63, 0.0)",
          "rgba(250, 22, 63, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      }
    };
  },

  methods: {
    selectArea() {
      this.noManPower.loaded = false;
      this.percentManPower.loaded = false;
      this.noLateIn.loaded = false;
      this.percentLateIn.loaded = false;
      this.noAbsent.loaded = false;
      this.percentAbsent.loaded = false;
      const deptID = this.selects.selectDept;
      const areaID = this.selects.selectArea;
      this.disableArea = false;

      let start;
      let end;

      if (this.selects.selectTime == "day") {
        start = moment()
          .startOf("isoWeek")
          .unix();

        end = moment()
          .endOf("isoWeek")
          .unix();
      } else if (this.selects.selectTime == "week") {
        start = moment()
          .startOf("month")
          .unix();

        end = moment()
          .endOf("month")
          .unix();
      } else if (this.selects.selectTime == "month") {
        start = moment()
          .startOf("year")
          .unix();

        end = moment()
          .endOf("year")
          .unix();
      }

      this.$http
        .get(
          `:9995/api/v1/graph/${this.selects.selectTime}/${start}/${end}/${this.selects.selectDept}/${this.selects.selectArea}`
        )
        .then(res => {
          console.log(res);
          if (!res.error) {
            let data = res.message;
            console.log(data)
            this.initChart(data.Data);
            this.getDepartment(data.Department)
            this.getArea(data.ServiceArea)
          }
        });
    },
    selectDepartment() {
      this.noManPower.loaded = false;
      this.percentManPower.loaded = false;
      this.noLateIn.loaded = false;
      this.percentLateIn.loaded = false;
      this.noAbsent.loaded = false;
      this.percentAbsent.loaded = false;
      const deptID = this.selects.selectDept;
      this.disableArea = false;

      let start;
      let end;

      if (this.selects.selectTime == "day") {
        start = moment()
          .startOf("isoWeek")
          .unix();

        end = moment()
          .endOf("isoWeek")
          .unix();
      } else if (this.selects.selectTime == "week") {
        start = moment()
          .startOf("month")
          .unix();

        end = moment()
          .endOf("month")
          .unix();
      } else if (this.selects.selectTime == "month") {
        start = moment()
          .startOf("year")
          .unix();

        end = moment()
          .endOf("year")
          .unix();
      }

      this.$http
        .get(
          `:9995/api/v1/graph/${this.selects.selectTime}/${start}/${end}/${this.selects.selectDept}/${this.selects.selectArea}`
        )
        .then(res => {
          console.log(res);
          if (!res.error) {
            let data = res.message;
            console.log(data)
            this.initChart(data.Data);
            this.getDepartment(data.Department)
            this.getArea(data.ServiceArea)
          }
        });
    },
    selectInterval() {
      this.noManPower.loaded = false;
      this.percentManPower.loaded = false;
      this.noLateIn.loaded = false;
      this.percentLateIn.loaded = false;
      this.noAbsent.loaded = false;
      this.percentAbsent.loaded = false;
      this.selects.selectDept = this.selects.department[0].value;
      this.selects.selectArea = this.selects.area[0].value;
      this.disableArea = true;

      let start;
      let end;

      if (this.selects.selectTime == "day") {
        start = moment()
          .startOf("isoWeek")
          .unix();

        end = moment()
          .endOf("isoWeek")
          .unix();
      } else if (this.selects.selectTime == "week") {
        start = moment()
          .startOf("month")
          .unix();

        end = moment()
          .endOf("month")
          .unix();
      } else if (this.selects.selectTime == "month") {
        start = moment()
          .startOf("year")
          .unix();

        end = moment()
          .endOf("year")
          .unix();
      }

      console.log(this.selects.selectTime);
      console.log(start, end);

      this.$http
        .get(`:9995/api/v1/graph/${this.selects.selectTime}/${start}/${end}/${this.selects.selectDept}/${this.selects.selectArea}`)
        .then(res => {
          console.log(res);
          if (!res.error) {
            let data = res.message;
            console.log(data)
            this.initChart(data.Data);
            this.getDepartment(data.Department)
          }
        });
    },
    initChart(data) {
      let timestamp = [];

      let available = [];
      let availablePercent = [];
      let lateIn = [];
      let lateInPercent = [];
      let absent = [];
      let absentPercent = [];

      for (let i = 0; i < data.length; i++) {
        if (this.selects.selectTime == "day") {
          let formatDate = moment(data[i].Date).format("YYYY-MM-DD");
          timestamp.push(formatDate);
        } else if (this.selects.selectTime == "week") {
          let formatWeek = moment(data[i].Date).format("W");
          let formatDate = moment(data[i].Date).format("YYYY-MM-DD");
          timestamp.push(`Week ${formatWeek} - ${formatDate}`);
        } else if (this.selects.selectTime == "month") {
          let formatDate = moment(data[i].Date).format("MMM");
          timestamp.push(formatDate);
        }

        available.push(data[i].Available);
        availablePercent.push(data[i].PercentAvailable);
        lateIn.push(data[i].Late);
        lateInPercent.push(data[i].PercentLate);
        absent.push(data[i].Absent);
        absentPercent.push(data[i].PercentAbsent);
      }

      // ################## AVAILABLE CHART ################## //
      let chartAvailable = {
        chartData: {
          labels: timestamp,
          datasets: [
            {
              label: "No of Man Power",
              fill: true,
              borderColor: "rgba(82, 222, 151, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(82, 222, 151, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: available
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(82, 222, 151, 0.5)",
          "rgba(82, 222, 151, 0.0)",
          "rgba(82, 222, 151, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      };

      let chartAvailablePercent = {
        chartData: {
          labels: timestamp,
          datasets: [
            {
              label: "Percentage of Man Power",
              fill: true,
              borderColor: "rgba(82, 222, 151, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(82, 222, 151, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: availablePercent
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(82, 222, 151, 0.5)",
          "rgba(82, 222, 151, 0.0)",
          "rgba(82, 222, 151, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      };
      this.noManPower = chartAvailable;
      this.percentManPower = chartAvailablePercent;

      // ################## LATE CHART ################## //
      let chartLateIn = {
        chartData: {
          labels: timestamp,
          datasets: [
            {
              label: "No of Late In",
              fill: true,
              borderColor: "rgba(255, 204, 0, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 204, 0, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: lateIn
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(255, 204, 0, 0.5)",
          "rgba(255, 204, 0, 0.0)",
          "rgba(255, 204, 0, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      };

      let chartLateInPercent = {
        chartData: {
          labels: timestamp,
          datasets: [
            {
              label: "Percentage of Late In",
              fill: true,
              borderColor: "rgba(255, 204, 0, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(255, 204, 0, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: lateInPercent
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(255, 204, 0, 0.5)",
          "rgba(255, 204, 0, 0.0)",
          "rgba(255, 204, 0, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      };

      this.noLateIn = chartLateIn;
      this.percentLateIn = chartLateInPercent;

      // ################## ABSENT CHART ################## //
      let chartAbsent = {
        chartData: {
          labels: timestamp,
          datasets: [
            {
              label: "No of Absent",
              fill: true,
              borderColor: "rgba(250, 22, 63, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(250, 22, 63, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: absent
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(250, 22, 63, 0.5)",
          "rgba(250, 22, 63, 0.0)",
          "rgba(250, 22, 63, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      };

      let chartAbsentPercent = {
        chartData: {
          labels: timestamp,
          datasets: [
            {
              label: "Percentage of Absent",
              fill: true,
              borderColor: "rgba(250, 22, 63, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(250, 22, 63, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: absentPercent
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(250, 22, 63, 0.5)",
          "rgba(250, 22, 63, 0.0)",
          "rgba(250, 22, 63, 0.0)"
        ],
        gradientStops: [1, 0.4, 0],
        loaded: true
      };

      this.noAbsent = chartAbsent;
      this.percentAbsent = chartAbsentPercent;
    },

    getDepartment(data) {
      this.selects.department = []
      console.log(data);
      
      let all = {
        label: "All",
        value: "*"
      }
      this.selects.department.push(all)

      for (let i = 0; i < data.length; i++) {
        console.log(data);
        let dept = {
          value: data[i].DeptID,
          label: data[i].DeptName
        };
        this.selects.department.push(dept);
        
      }
      console.log(this.selects.department)
    },
    getArea(data) {
      this.selects.area = []
      console.log(data);

      let all = {
        label: "All",
        value: "*"
      }
      this.selects.area.push(all)
      
      for (let i = 0; i < data.length; i++) {
        let serviceArea = {
          value: data[i].ServiceAreaID,
          label: data[i].ServiceAreaName
        };

        this.selects.area.push(serviceArea);
      }
    }
  },
  mounted() {
    // this.getDepartment();
    // this.getArea();
    
  },
  created() {
    this.selects.selectTime = this.selects.time[0].value;
    this.selects.selectDept = "*";
    this.selects.selectArea = "*";
    this.selectInterval();
  }
};
</script>
<style lang="scss" scoped>
.footer-font {
  font-size: 105%;
}
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.test {
  width: 800px;
}
.dialog {
  margin-left: 30%;
}
</style>
